export default {"src":"/_next/static/media/logoOutline_29x24.e9d4b6c2.svg","height":24,"width":29,"blurWidth":0,"blurHeight":0};